<template lang="html">
    <div class="multi-avatar">
        <!-- call multiple times the avatar component with-->
        <template v-for="(single, index) in item">
            <template v-if="index < (number)">
                <template v-if="itemKey != null">
                    <avatar :item="single[itemKey]" :size="size" :isFaker="isFaker"></avatar>
                </template>
                <template v-else>
                    <avatar :item="single" :size="size" :isFaker="isFaker"></avatar>
                </template>
            </template>
        </template>
        <span v-if="count>0"> + {{count}}</span>
    </div>
</template>

<script>
    import Avatar from './Avatar.vue'

    export default {

        components:{Avatar},

        props:{
            size: {
                type: String,
                required: false,
                default: '5rem'
            },
            item: {
                type: Array,
                required: true
            },
            isFaker: {
                type: Boolean,
                required: false,
                default: false
            },
            itemKey: {
                type: String,
                required: false,
                default: null
            },
            number: {
                type: Number,
                required: false,
                default: 3
            }
        },

        data() {
            return {

            }
        },

        computed: {
            count() {
                return this.item.length - this.number
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .multi-avatar{
        display:inline

        & >>> .avatar{
            margin-right:0

            &:nth-of-type(n+2){
                margin-left:-2.9rem!important
            }
        }

        span{
            font-size:2rem
            vertical-align:middle
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/avatar/MultiAvatar.vue